module.exports = __webpack_public_path__ + "img/container.ebd85ac3.png";